// 사이드바 상단 로고/서비스명 — refine ThemedTitleV2를 대체한다.
// ThemedTitleV2는 아이콘 크기(24px)가 고정이고 텍스트도 h6 그대로라 로고를 키울 수 없어
// 직접 구현한다(구조/동작은 ThemedTitleV2와 동일, 크기만 확대).

import React from "react";
import MuiLink from "@mui/material/Link";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { useRouterContext, useLink, useRouterType } from "@refinedev/core";

export interface SiderTitleProps {
  collapsed: boolean;
  text: string;
  icon: React.ReactNode;
}

export const SiderTitle: React.FC<SiderTitleProps> = ({ collapsed, text, icon }) => {
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();
  const ActiveLink = routerType === "legacy" ? LegacyLink : Link;

  return (
    <MuiLink
      to="/"
      component={ActiveLink}
      underline="none"
      sx={{
        display: "flex",
        alignItems: "center",
        // 아이콘은 항상 왼쪽 정렬(flex-start, 기본값) — 접힘 여부에 따라 정렬
        // 기준을 바꾸지 않는다. 대신 헤더 Paper의 paddingLeft를 접힘 여부와
        // 무관하게 16px로 고정해뒀다(index.tsx) — 그래야 접기/펼치기 전환 시
        // 아이콘이 좌우로 움직이지 않고, 아래 메뉴 아이콘들의 중앙 정렬
        // x좌표와도 거의 일치해 자연스럽게 정렬돼 보인다.
        flex: "1 1 auto",
        // minWidth:0 없이는 flex item이 콘텐츠 크기 밑으로 줄어들지 못해 폰트를
        // 키운 서비스명이 접기 버튼을 화면 밖으로 밀어낸다(펼친 상태에서만 해당).
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      <SvgIcon height="32px" width="32px" color="primary" sx={{ fontSize: 32, flexShrink: 0 }}>
        {icon}
      </SvgIcon>
      {!collapsed && (
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          // 헤더 폭(접기 버튼 포함) 안에서 실측했을 때 137px가 한계였다(브라우저 실측,
          // 2026-09-04). 14px면 128px로 여유 있게 들어가 말줄임(ellipsis)이 걸리지 않는다.
          fontSize="0.875rem"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          minWidth={0}
          marginLeft="12px"
        >
          {text}
        </Typography>
      )}
    </MuiLink>
  );
};
